/**
 * created by xcc
 * 阵地备案申请待办处理
 */
import React from 'react';
import {connect} from "react-redux";
import BaseComponent from "../../../../../base/BaseComponent";
import PositionAdd from "../../../../positionManage/components/info/PositionAdd";
import {uuid} from "../../../../../utils";

class PositionAudit extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};

    isSupport(data) {
        this.data = data;
        if (this.data && this.data.data && this.data.data.id && this.data.activitiCategoryKey === "positionAudit") {
            return true;
        }
        return false;
    };

    call = () => {
    } // 刷新代办列表

    //刷新回调
    handle = (data, call) => {
        this.call = call;
        this.positionAdd.showEditModal(data.data.id);
    };

    loadKey = uuid();

    render() {
        return (
            <div style={{display: 'none'}}>
                <PositionAdd
                    key={this.loadKey}
                    ref={ref => this.positionAdd = ref}
                    onCancel={() => {
                        this.loadKey = uuid();
                        this.setState({})
                    }}
                    onOkCall={() => {
                        this.loadKey = uuid();
                        this.call && this.call();
                    }}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(PositionAudit)